

const styles = {
  block: "-db",
  none: "-dn"
}

export class ResourceCenterApiService {
  constructor(apiUrlService, filterService, resourceCenterfactory, settings) {
    this.widgetSettings = settings;
    this.updateGrid = this.updateGrid.bind(this);
    this.apiUrlService = apiUrlService;
    this.filterService = filterService;
    this.pageSize = window.ResourceCenterSettings.ODataSettings.PageSize;
    this.cachedResponses = new Map();
    this.lastRequestURL;
    this.resourceCenterObjectFactory = resourceCenterfactory;
  }

  updateGrid(pageNumber) {
    //GET the API call based on DOM selection.
    const apiRequest = this.apiUrlService.generate(pageNumber, this.filterService.getSelection());
    const resourceItems = {};
    let html = "";
    const cachedReponse = this.cachedResponses.get(apiRequest);
    this.lastRequestURL = this.normalizeRequestUrl(apiRequest);

    if (cachedReponse) {
      cachedReponse.response.totalItemsCount > 0 ? this.showMissingResourcesMessage(false) : this.showMissingResourcesMessage(true);

      document.getElementById(this.widgetSettings.ItemsContainer).innerHTML = cachedReponse.html;
      return Promise.resolve(cachedReponse.response);
    }

    const result = fetch(apiRequest, {
      method: 'GET',
    })
      .then((response) => {
        const isLastUrlResponse = this.lastRequestURL === response.url;
        if (response.ok && (isLastUrlResponse || !response.url)) {
          return response.json();
        }
        else if (!isLastUrlResponse) {
          return Promise.reject(new Error("Awaiting last response."));
        }
        else {
          return Promise.reject(new Error(`There was a problem with your request - ${response.url}.`));
        }
      })
      .then(data => {
        resourceItems.resources = data.value;
        resourceItems.dataCount = data['@odata.count'];
        resourceItems.pagesCount = Math.ceil(resourceItems.dataCount / this.pageSize);

        if (resourceItems.dataCount == 0 || data.value.length == 0) {
          this.showMissingResourcesMessage(true);
        }
        else {
          this.showMissingResourcesMessage(false);
          let idsWithMissingRelatedMedia = [];
          data.value.forEach(item => {
            const imageFieldName = Object.keys(window.ResourceCenterSettings.ODataSettings.ExpandedFields.Image)[0];
            if (item[imageFieldName] && (item[imageFieldName].length == 0 || (item.File && item.File.length == 0))) {
              idsWithMissingRelatedMedia.push(item.Id);
            }
          });
          return this.getRelatedMedia_english(idsWithMissingRelatedMedia);
        }
      })
      .then(images => {
        resourceItems.images = images;
        return resourceItems;
      })
      .then(() => {
        if(this.widgetSettings.GroupingSettings){
          let groupedCollection = this.groupItems(resourceItems.resources, this.widgetSettings.GroupingSettings);
          groupedCollection.forEach(item => {
            html += this.itemHTML(item, resourceItems.images);
          });
        }
        else{
          resourceItems.resources.forEach(item => {
            html += this.itemHTML(item, resourceItems.images);
          });
        }
        document.getElementById(this.widgetSettings.ItemsContainer).innerHTML = html;
        const response = { totalItemsCount: resourceItems.dataCount, totalPagesCount: resourceItems.pagesCount, currentPage: pageNumber };
        this.cachedResponses.set(apiRequest, { response, html });

        return response;
      });

    return result;
  }

  normalizeRequestUrl(urlString) {
    const absoluteUrlString = window.location.origin + urlString;
    let encodedUrlString;
    try {
      encodedUrlString = new URL(absoluteUrlString).href;
    }
    catch {
      encodedUrlString = absoluteUrlString;
    }

    return encodedUrlString;
  }

  itemHTML(item, relatedMedia) {
    const itemHtml = this.resourceCenterObjectFactory.getResourceItemHtmlProvider(this.filterService).getItemHtml(item, relatedMedia);
    const result = itemHtml.trim().split('\n').map(x => x.trim()).join('');

    return result;
  }

  getRelatedMedia_english(itemIds) {
    if (itemIds.length == 0) {
      return "";
    }

    const apiRequestUrl = this.apiUrlService.getImagesUrl_english(itemIds);
    const result = fetch(apiRequestUrl, {
      method: 'GET'
    }).then(response => {
      if (response.ok) {
        return response.json().then(data => {
          return data.value;
        });
      }
    });

    return result;
  }

  showMissingResourcesMessage(showMessage) {
    const missingResourcesMessageDiv = document.querySelector(`#${this.widgetSettings.MissingItemsContainer}`);
    if (missingResourcesMessageDiv) {
      let classToRemove = showMessage ? styles.none : styles.block;
      let classToAdd = classToRemove === styles.none ? styles.block : styles.none;

      missingResourcesMessageDiv.classList.remove(classToRemove);
      missingResourcesMessageDiv.classList.add(classToAdd);
    }
  }

  groupItems(initialCollection, groupingSettings){
    let itemsGroupingMap = new Map();
    let otherGroupData = {};
    otherGroupData.Title = 'Other';
    otherGroupData.Id = 'other';
    otherGroupData.UrlName = 'other';

    for(let item of initialCollection){
      let isInGroup = false;
      for(let taxon of item[groupingSettings.GroupingProperty]){
        if (groupingSettings.ParentTaxonToUseId && taxon.ParentId !== groupingSettings.ParentTaxonToUseId){
          continue;
        }

        this.addToGroupMap(item, taxon, itemsGroupingMap);

        isInGroup = true;
      }

      if(!isInGroup){
        this.addToGroupMap(item, otherGroupData, itemsGroupingMap);
      }
    }

    let itemsInColumns = [];

    for(let column of groupingSettings.GroupsData){
      let itemsInColumn = [];
      for(let taxonId of column){
        if(itemsGroupingMap.has(taxonId)){
          itemsInColumn.push(itemsGroupingMap.get(taxonId));
          itemsGroupingMap.delete(taxonId);
        }
      }
      itemsInColumns.push(itemsInColumn);
    }

    if (itemsGroupingMap.size > 0){
      let otherGroup = null;
      itemsGroupingMap.forEach((value, key) => {
        if(key !== 'other'){
          itemsInColumns[itemsInColumns.length - 1].push(value);
        }
        else{
          otherGroup = value;
        }
      });

      if(otherGroup){
        itemsInColumns[itemsInColumns.length - 1].push(otherGroup);
      }
    }

    return itemsInColumns;
  }

  addToGroupMap(item, data, map){
    if(map.has(data.Id)){
      map.get(data.Id).items.push(item);
    }
    else{
      let itemsGroup = {};
      itemsGroup.title = data.Title;
      itemsGroup.urlName = data.UrlName
      itemsGroup.items = [item]
      map.set(data.Id, itemsGroup);
    }
  }
}
